// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"99b8740a","170":"e085b958","244":"7cbc0e37","664":"74faf2fe"}[chunkId] + ".chunk.css";
};